import { render, staticRenderFns } from "./LeoImage.vue?vue&type=template&id=dcd55990&scoped=true"
import script from "./LeoImage.vue?vue&type=script&lang=ts"
export * from "./LeoImage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd55990",
  null
  
)

export default component.exports